import React, { useRef } from 'react'
import { chipImg, frameImg, frameVideo } from '../utils'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

import { animateWithGsaP } from '../utils/animations'

const Chip = () => {
    const videoRef = useRef();
    useGSAP(()=>{
        gsap.from('#chip',{
            scrollTrigger:{
            trigger:'#chip',
                start:'20% bottom'
            },
            opacity:0,
            scale:2,
            duration:2,
            ease:'power2.inOut'
        })
        animateWithGsaP('.g_fadeIn',{
            opacity:1,
            y:0,
            duration:1,
            ease:'power2.inOut'
        })
     
         

    },[])
  return (
    <section className='common-padding'>
        <div className='screen-max-width'>
            <div id='chip' className='flex-center w-full my-20'>
                <img src={chipImg} alt='chip' width={180} height={180}/>

            </div>
            <div className='flex flex-col items-center'>
                <h2 className='hiw-title'>
                    A17 PRO Chip
                    <br /> A monster win for gaming

                </h2>
                <p className='hiw-subtitle'>
                    Its here !!!. Its the biggest redesign in the history of apple GPUs

                </p>

            </div>
            <div className='mt-10 md:mt-20 mb-14'>
                <div className='relative h-full flex-center'>
                    <div className='overflow-hidden'>
                        <img src={frameImg} alt='frame'className='bg-transparent relative z-10'/>

                    </div>
                    <div id='frameVideo' className='hiw-video'>
                        <video id='frameVideo' className='pointer-events-none' playsInline preload='none'muted autoPlay ref={videoRef}>
                            <source src={frameVideo} type='video/mp4'/>
                        </video>

                    </div>

                </div>
                <p className='text-grey text-semibold text-center mt-3'>
                    Honkai: Star Rail
                </p>
                </div>
                   <div className='hiw-text-container'>
                            <div className=' flex flex-1 justify-center flex-col'>
                                <p className='hiw-text g_fadeIn'>
                                The A17 Pro chip takes mobile gaming to unprecedented heights. {''}
                                    <span className='text-white'>
                                    Built with a cutting-edge 3nm architecture, it delivers console-quality graphics and unmatched speed right in your pocket.

                                    </span>,Experience incredibly lifelike visuals, ray tracing for real-time lighting effects, and smoother gameplay with up to 20% faster GPU performance.


                                </p>

                            
                                <p className='hiw-text g_fadeIn'>
                                    Mobile {''}
                                    <span className='text-white'>
                                    gaming will look and feel so immersive

                                    </span>,with incredibly detailed character and gaming enviroments
                                </p>
                            </div>


                            
                            <div className='flex-1 flex justify-center flex-col g_fadeIn'>
                                <p className='hiw-text'>New</p>
                                <p className='hiw-bigtext'>Pro Class GPU</p>
                                <p className='hiw-text'>With 6 Cores</p>

                            </div>
                            </div>

                        </div>

            

        
    </section>
  )
}


export default Chip;